export const selectIsPrimaryConnection = (state) => state.websocket.meta.isPrimaryConnection;
